<template lang="pug">
    div
        v-form(ref="form")
            .title Monto:
            v-text-field.title#transbank-pay-input(
                ref="tbkAmountInput"
                :mask="mixCurrencyMask(transbankPayment, 12)"
                placeholder="Ingrese monto pagado por transbank"
                prefix="$"
                v-model="transbankPayment"
                :rules='[rules.required, rules.validPayment, rules.notZero]'
                @input="setTransbankPayment()"
                @keyup.enter="handleEnter()"
                )
            template(v-if="!isTransbankIntegrated")
                v-divider
                .title N° de voucher
                v-text-field.title#transbank-voucher-num-input(
                    ref="tbkNumInput"
                    solo
                    mask="######"
                    placeholder="Ingrese n° de voucher"
                    v-model="voucher"
                    :rules='[rules.required, rules.validVoucher]' 
                    validate-on-blur
                    @keyup.enter="handleEnter()"
                    tabindex="-1"
                    )
</template>

<script>
// Mixins:
import PaymentRules from '@/mixins/PaymentRules'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import JSUtils from '@/mixins/JSUtils'
import { mapState, mapGetters, mapActions } from 'vuex'
import { getTransbankNumber } from '@/services/API/Integration/'

export default {
    name: 'transbank-payment',
    props: {},
    data: function() {
        return {
            voucher: '',
            transbankPayment: '',
        }
    },
    computed: {
        integrationCountersAreEnabled() {
            return JSON.parse(process.env.VUE_APP_ENABLE_INTEGRATION_COUNTERS)
        },
        ...mapState('CashDeskModule', {
            paymentMethod: 'paymentMethod',
            total: state => state.total,
        }),

        ...mapGetters('CashDeskModule', {
            totalToPay: 'totalToPay',
        }),

        ...mapState('SessionModule', ['isTransbankIntegrated']),
        voucherLength() {
            return this.voucher ? this.voucher.length : 0
        },
        allTransbankDataSet: function() {
            console.log(
                'CHECK',
                this.transbankPayment,
                this.transbankPayment >= 50,
                this.transbankPayment <= this.totalToPay,
                this.voucher,
                ('' + this.voucher).length
            )
            let isSet =
                this.transbankPayment &&
                parseInt(this.transbankPayment) >= 50 &&
                parseInt(this.transbankPayment) <= this.totalToPay
            if (!this.isTransbankIntegrated)
                isSet =
                    isSet && this.voucher && ('' + this.voucher).length === 6
            return isSet
            /*return this.isTransbankIntegrated*/
            /*? this.transbankPayment &&*/
            /*parseInt(this.transbankPayment) >= 50 &&*/
            /*parseInt(this.transbankPayment) <= this.totalToPay*/
            /*: this.voucherLength === 6 &&*/
            /*this.transbankPayment &&*/
            /*parseInt(this.transbankPayment) >= 50 &&*/
            /*parseInt(this.transbankPayment) <= this.totalToPay*/
        },
    },
    methods: {
        ...mapActions('CashDeskModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
        }),
        setTransbankPayment() {
            if (parseInt(this.transbankPayment) === 0) {
                this.setPayment('')
            } else {
                this.setPayment(this.transbankPayment)
            }
        },
        handleEnter() {
            if (
                !this.transbankPayment ||
                parseInt(this.transbankPayment) > this.totalToPay
            ) {
                this.$nextTick(() => this.$refs.tbkAmountInput.focus())
                this.$refs.form.validate()
                return
            } else if (
                !this.isTransbankIntegrated &&
                (!this.voucher || this.voucherLength < 6)
            ) {
                this.$nextTick(() => this.$refs.tbkNumInput.focus())
                this.$refs.form.validate()
                return
            } else if (
                this.transbankPayment &&
                (!this.isTransbankIntegrated || this.voucherLength === 6)
            ) {
                this.$refs.form.validate()
                this.$emit('confirm')
            }
        },
    },
    watch: {
        /**
         * @description updates payment details in store depending of they are fully set in form or not.
         */
        allTransbankDataSet: {
            immediate: true,
            handler: function(newVal, oldVal) {
                if (newVal) {
                    this.setPayment(this.transbankPayment)
                    let payload = {
                        voucher: this.isTransbankIntegrated
                            ? null
                            : this.voucher,
                    }
                    this.setPaymentDetail(payload)
                } else {
                    this.setPayment('')
                    this.setPaymentDetail(null)
                }
            },
        },

        /**
         * @description If payment method changes (example: from debit to credit),
         * voucher data and payment data is reseted to their original values.
         */
        paymentMethod: function(newVal, oldVal) {
            // this.voucher = ''
            this.transbankPayment = this.totalToPay.toString()
        },
    },
    components: {},
    mixins: [PaymentRules, CurrencyUtils, JSUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // beforeMount: function(){...},
    mounted: async function() {
        console.log('mounted')
        if (!this.isTransbankIntegrated) this.voucher = ''
        this.$nextTick(() =>
            this.$nextTick(() => this.$refs.tbkAmountInput.focus())
        )
        if (this.isTransbankIntegrated || !this.integrationCountersAreEnabled)
            return
        let number = await getTransbankNumber()
        let tbk = number
        let len = '' + number
        len = len.length
        let dif = 6 - len
        if (dif && dif > 0) {
            for (let i = 0; i < dif; i++) {
                tbk = '0' + tbk
            }
        }
        if (!this.isTransbankIntegrated) this.voucher = tbk
        this.initialTransbankNumber = tbk
    },
    // beforeUpdate: function(){...},
    updated: function() {
        if (!this.transbankPayment) this.transbankPayment = this.totalToPay
    },
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>
